import { render } from "./App.vue?vue&type=template&id=23da9d7e&scoped=true"
const script = {}

import "./App.vue?vue&type=style&index=0&id=23da9d7e&lang=scss&scoped=true"

import exportComponent from "/Users/zhaolong/Documents/work/puyan/sichouzhilu/sczl-js-user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23da9d7e"]])

export default __exports__